import { render } from "./ViewBase.vue?vue&type=template&id=94f9d1b8&lang=pug"
import script from "./ViewBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBase.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__